import { TaskStatus } from 'app/task/models/task-status.enum';

export function mapStatus(value: string, isLinked: boolean): string {
  const startTaskKey: string = '$btn_start_task';
  const continueTaskKey: string = '$btn_continue_task';
  const completeTaskKey: string = '$btn_complete_task';
  const viewTaskCopy: string = '$btn_view_task';
  let string: string = viewTaskCopy;
  switch (value) {
    case TaskStatus.NEW:
      string = isLinked ? startTaskKey : completeTaskKey;
      break;
    case TaskStatus.IN_PROGRESS:
      string = isLinked ? continueTaskKey : completeTaskKey;
      break;
  }
  return string;
}
